<script>
  import { Link } from "svelte-routing";
  import { _ as t } from "svelte-i18n";
  import { Button, Icon } from "t2c-components";

  import Headroom from "components/headroom/Index.svelte";
  import LangSwitch from "./LangSwitch.svelte";
  import { ORGANIZATION_INFO_QUERY } from "./queries";

  import { query } from "svelte-apollo";
  import { client } from "apollo.js";

  export let logout;

  const organizationDetail = query(client, {
    query: ORGANIZATION_INFO_QUERY,
  });

  const keepSelected = false;
  const getProps = ({ location, href, isPartiallyCurrent, isCurrent }) => {
    const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

    // The object returned here is spread on the anchor element's attributes
    if (isCurrent || (keepSelected && isActive)) {
      return { class: "menu-nav-item active" };
    }
    return { class: "menu-nav-item" };
  };

  const handleLogout = () => {
    logout();
  };

  let open = false;

  const handleCloseMenu = () => {
    open = false;
  };

  const handleOpenMenu = () => {
    open = true;
  };
</script>

<Headroom duration="200ms" offset={24} tolerance={0}>
  <div class="mobile">
    {#await $organizationDetail then result}
      <div class="mobile-logo">
        {#if result.data.organizationConfig.logoHash}
          <img
            class="mobile-logo"
            src={`/download-file/logo/${result.data.organizationConfig.id}?hash=${result.data.organizationConfig.logoHash}`}
            alt="logo"
          />
        {/if}
      </div>
      <div class="mobile-title">
        {result.data.organizationConfig
          ? result.data.organizationConfig.name
          : "Portale Clienti"}
      </div>
      <div on:click={handleOpenMenu}>
        <Icon medium icon="mobile-menu" />
      </div>
    {/await}
  </div>
</Headroom>

<div class={`mobile-menu ${open ? "open" : ""}`}>
  <div class="mobile-menu-logo">
    {#await $organizationDetail then result}
      {#if result.data.organizationConfig.logoHash}
        <img
          class="mobile-logo"
          src={`/download-file/logo/${result.data.organizationConfig.id}?hash=${result.data.organizationConfig.logoHash}`}
          alt="logo"
        />
      {/if}
    {/await}
  </div>
  <div class="mobile-menu-icon" on:click={handleCloseMenu}>
    <Icon medium icon="close" />
  </div>
  <div>
    <Link {getProps} to="/">{$t("dashboard")}</Link>
    <Link {getProps} to="/personal">{$t("personalData")}</Link>
    <Link {getProps} to="/activities">{$t("activityLogs")}</Link>
    <Link {getProps} to="/settings">{$t("settings")}</Link>
  </div>
  <Icon icon="mobile-dot" />
  <div class="menu-nav-item">
    <Button text={$t("logout")} on:click={handleLogout} />
  </div>
  <div class="mobile-languages">
    <LangSwitch />
  </div>
  <div class="mobile-copy">
    <div>
      2021 &copy; Time2Client
      <a href="https://www.iubenda.com/termini-e-condizioni/64039599">Term</a>
    </div>
    <div>
      <a href="https://www.iubenda.com/privacy-policy/64039599">
        Privacy Policy
      </a>
    </div>
    <div>
      <a href="https://www.iubenda.com/privacy-policy/64039599/cookie-policy">
        Cookie Policy
      </a>
      /
      <a href="https://time2client.com/contacts">Contacts</a>
    </div>
  </div>
</div>

<style>
  .mobile {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #eee;
    padding: 6px 24px;
  }

  @media only screen and (min-width: 600px) {
    .mobile {
      display: none;
    }
  }

  .mobile-title {
    font-size: 20px;
    text-transform: uppercase;
    padding: 12px 0;
    flex: 1;
  }

  .mobile-logo {
    max-width: 50px;
    padding-right: 12px;
  }

  .mobile-menu {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #eee;
    transition: transform ease-in-out 0.5s;
    transform: translateX(100%);
    z-index: 5;
  }

  .mobile-menu.open {
    transform: translateX(0);
  }

  .mobile-menu-icon {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  :global(.menu-nav-item) {
    display: block;
    padding: 24px 0;
    text-transform: uppercase;
    text-align: center;
    font-size: 18px;
  }

  :global(.menu-nav-item.active) {
    color: var(--accent);
  }

  .mobile-menu-logo {
    position: absolute;
    top: 12px;
    left: 12px;
  }

  .mobile-languages {
    position: absolute;
    bottom: 12px;
    right: 24px;
  }

  .mobile-copy {
    position: absolute;
    bottom: 12px;
    left: 12px;
    font-size: 10px;
  }

  .mobile-copy > * {
    margin-top: 6px;
  }
</style>
